export default __webpack_public_path__ + "static/media/pointerCur.65bb39c6.png";